import { useQuery } from '@tanstack/react-query';
import type { AlDailyWindowDto } from '@signalvote/shared';
import { authService } from '../../services/authService';
import { apiJson } from './apiFetch';
import { queryKeys } from '../../lib/queryKeys';
import { useCampaignStore } from '../../stores';

// ============================================================================
// AL daily-report window (GitHub #81) — GET /api/finance/compliance/al-daily-window.
// Powers the standing "you're in the daily-report window" banner in the Close hub's
// alert band. `isInWindow` drives visibility; the bounds + electionDate name the
// window; ruleText is the treasurer-facing explanation (always present).
// ============================================================================

export function useAlDailyWindow() {
  const { selectedCampaign } = useCampaignStore();

  return useQuery({
    queryKey: queryKeys.finance.alDailyWindow(),
    queryFn: () =>
      apiJson<AlDailyWindowDto>('/api/finance/compliance/al-daily-window', {
        error: 'Failed to fetch the daily-report window',
      }),
    enabled: authService.isAuthenticated() && !!selectedCampaign,
    staleTime: 60_000,
  });
}
